

import Vue from 'vue'
import FastClick from './utils/fastclick'
import router from './router'
import App from './App'
import store from './store'

FastClick.attach(document.body)

import VueCookie  from 'vue-cookie';
Vue.use(VueCookie);

import axios from './axios'
Vue.prototype.$http = axios;

import utils from './utils/util';
Vue.prototype.$utils = utils


import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import BusPlugin from 'vux/src/plugins/bus/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'

Vue.use(LoadingPlugin, {position: 'middle'})
Vue.use(ToastPlugin, {position: 'middle'})
Vue.use(ConfirmPlugin)
Vue.use(AlertPlugin)
Vue.use(BusPlugin)

import jsCookie from 'js-cookie';
Vue.prototype.$cookie = jsCookie;

Vue.config.productionTip = false


import wx from 'weixin-js-sdk';
Vue.prototype.$wx = wx;


import Bridge from './bridge'
Vue.prototype.$bridge = Bridge


import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload)



import {VueMasonryPlugin} from 'vue-masonry';
Vue.use(VueMasonryPlugin)


Vue.filter('fommatNum', val=>{
if(val >= 10000000){
val = Math.round(val / 10000000 * 100) / 100 +'KW';
}else if (val >= 10000) {
val = Math.round(val / 10000 * 100) / 100 +'W';
} else if(val >= 1000) {
val = Math.round(val / 1000 * 100) / 100 +'K';
} else {
val = val;
}
return val;
})

store.registerModule('vux', {
state: {
direction:'forward'
},
mutations: {
updateDirection (state, payload) {
state.direction = payload.direction
}
}
})

const history = window.sessionStorage

let historyCount = history.getItem('count') * 1 || 0
history.setItem('/', 0)
let isPush = false
let endTime = Date.now()
let methods = ['push', 'go', 'replace', 'forward', 'back']

document.addEventListener('touchend', () => {
endTime = Date.now()
})
methods.forEach(key => {
let method = router[key].bind(router)
router[key] = function (...args) {
isPush = true
method.apply(null, args)
}
})



router.beforeEach(function (to, from, next) {
const toIndex = history.getItem(to.path)
const fromIndex = history.getItem(from.path)

if (toIndex) {
if (!fromIndex || parseInt(toIndex, 10) > parseInt(fromIndex, 10) || (toIndex === '0' && fromIndex === '0')) {
store.commit('updateDirection', {direction: 'forward'})
} else {

if (!isPush && (Date.now() - endTime) < 377) {
store.commit('updateDirection', {direction: ''})
} else {
store.commit('updateDirection', { direction: 'reverse' })
}
}
} else {
++historyCount
history.setItem('count', historyCount)
to.path !== '/' && history.setItem(to.path, historyCount)
store.commit('updateDirection', {direction: 'forward'})
}







console.log(utils.judgeBrowser())
if(utils.os() == 'androidApp' || utils.os() == 'iosApp' || utils.judgeBrowser() == 3){
next()
}else{
if (to.meta.requireAuth && !sessionStorage.getItem('token')){
sessionStorage.setItem('url',to.fullPath);
sessionStorage.setItem('from',from.fullPath);
switch (utils.judgeBrowser()) {
case 1:
next({path:'/author',replace: false});
break;
case 2:
next({path:'/login',replace: false});
break;
default:
next({path:'/login',replace: false});
break;
}
return false
}else{
if(to.meta.requireAuth && sessionStorage.getItem('hasPhone') && to.fullPath.indexOf('promotionIndex') < 0){
next({path:'/bind',replace: false});
}else{
next();
}

}
}

})

import { globalMethods } from '@/utils/mixins'
Vue.mixin(globalMethods)


/* eslint-disable no-new */
new Vue({
store,
router,
render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js